export const environment = {
  production: false,

  //API标准格式形如：http://xxx.xxx.xxx.xxx/  （注意最后斜杠）

  //#region  seeker基础平台微服务api地址配置区域
  seekerWebAPI:"http://192.168.10.13:8114/sw-basic/",          //基础平台微服务api 

  fileWebAPI:  "http://192.168.10.13:8114/sw-file/",           //文件处理微服务api

  activitiWebAPI:"http://192.168.10.13:8114/sw-activiti/",     //工作流微服务api 
    
  scheduleWebApi: "http://192.168.10.13:8114/sw-scheduler/",   //任务调度微服务api

  ruleWebApi: "http://192.168.10.13:8114/sw-rule/",            //规则引擎微服务api

  webSoketApi:   "ws://192.168.10.96:8041/",                   //消息队列   
  
  outWebAPI:"http://192.168.10.96:8074/",                      //out第三方服务api(如与钉钉同步)

  smsWebAPI:"http://192.168.10.96:8021/",                      //短信验证码发送服务api

  esWebAPI:"http://192.168.10.13:8114/sw-es/",                 //es全文检索服务

  saasWebAPI:"http://192.168.10.13:8114/sw-saas/",             //saas租户管理服务api

  staticFileUrl:"http://192.168.10.96:8081/fileUpload/",      //静态资源文件web站点

  panoUrl: "http://192.168.10.75:8002/",

  onlineOfficeWebAPI:"http://192.168.10.210:9999/",            //文件在线编辑服务api

  iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",            //openseadragon大图预览插件

  uploadDirectory: "swseeker",                                 //文件上传目录（以项目分文件夹存储）

  //#endregion 

  //#region 智慧博物馆业务产品领域微服务api地址配置区域
  cmsWebAPI: "http://192.168.10.13:8114/sw-cms/",               //门户内容服务api  

  damWebAPI: "http://192.168.10.13:8114/sw-dam/",               //观众系统服务api

  trmWebAPI: "http://192.168.10.13:8114/sw-trm/",               //票务预约服务api

  actWebAPI: "http://192.168.10.13:8114/sw-act/",               //活动预约服务api

  volWebAPI: "http://192.168.10.13:8114/sw-vve/",               //志愿者微服务api

  vipWebAPI: "http://192.168.10.13:8114/sw-vve/",               //会员微服务api

  expWebAPI: "http://192.168.10.13:8114/sw-vve/",               //讲解员微服务api

  wecWebAPI: 'http://192.168.10.13:8114/sw-cms/',               //微信后台微服务api

  apfWebAPI: "http://192.168.10.13:8114/sw-apf/",               //观众客流分析微服务api

  ckfWebAPI: "http://192.168.10.13:8114/sw-ckf/",               //藏品系统微服务api

  drmWebAPI: "http://192.168.10.13:8114/sw-drm/",               //数字资源微服务api

  amsWebAPI: "http://192.168.10.13:8114/sw-oms/",               //固定资产微服务api

  dssWebAPI: "http://192.168.10.13:8114/sw-dss/",               //决策支持微服务api

  dpsWebAPI: "http://192.168.10.13:8114/sw-dps/",               //研发内部使用API
  //#endregion

  //#region  其他业务产品领域微服务api地址配置区域
  pcrWebAPI: "http://192.168.10.13:8114/sw-pcr/",               //预防性保护系统API

  cirWebAPI: "",

  famWebAPI:"http://192.168.10.13:8114/sw-fam-gugong/",

  apmWebAPI: "http://192.168.10.13:8114/sw-apm-gugong/",

  apoWebAPI: "",

  proWebAPI: "",

  webSocketPcrUrl: "",

  kgsWebAPI: "http://192.168.10.97:8095/",                     //知识图谱微服务api

  mapWebAPI: "",                                               //知识地图微服务api

  rmsWebAPI: "http://192.168.10.66:9990/sw-rms",               //数据资源管理微服务api

  sesWebAPI: "http://192.168.10.66:9990/sw-ses",               //知识图谱检索微服务api

  qasWebAPI: "http://192.168.10.66:9990/sw-qas",               //问答管理微服务api
  //#endregion

  //#region 项目基本属性配置区域
  encryptedPassword:false,                                     //是否加密密码

  multiTenancy:false,                                           //是否开启多租户管理模式
  
  systemCode:'BWY_GUGONG',                                               //系统编号（默认不填，multiTenancy为false必填）

  isVcode: false,                                               //登录界面是否有验证码,默认需要验证码,值为true

  isSliderCode: true,                                 //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false

  isRelateDingTalk: false,                                      //是否有与钉钉相关的业务

  dingTalkAgentId:"325262018",                                 //代理id,与钉钉同步的接口

  syncToUserResource:true,                                     //在文件上传组件中出现 ‘同步至数字资源’ 按钮

  singleTab:false,                                             //是否单页签交互，默认为false（即多tab页签交互）

  enbaleCustomLayout:false,                                     //工作台是否开启自定义布局

  isLoadAllMenu:true,                                         //是否按模块加载所有子级菜单，默认为false
 
  tabNumber:10,                                                //tab标签页最多显示数量（singleTab为false有效）

  singleMenu:false,                                            //头部是否用所有门户替换一级菜单
 
  openDefaultMenu:true,                                        //是否打开第1个菜单：默认为false

  isSwitchSkin: false,                                         //header头部右上角是否可切换项目皮肤，默认为true 显示（即可切换项目皮肤），false不显示（不能切换）
  
  defaultLanguage:'zh-CN',                                     //国际化默认语言版本,zh-CN表示中文；en-US表示英文; 为空字符串或为null表示没有国际化功能，不能切换语言

  projectName: "智慧博物馆统一登录平台",                         //系统名称，打包编译后中文会进行Unicode编码
  defaultPortal: "/oa/dashboard",                                 //默认工作门户，配置的此路由对应的路由文件中要加上 canDeactivate: [SwUnfocusGuardService]，才能实现从首页离开刷新左侧菜单

  customerName: "田野考古数字化管理平台",                                   //客户名称，打包编译后中文会进行Unicode编码
  fullScreen: "/oa/portal,/fam/aps/ProjectDisplay,/oa/dashboard",                                    //需要全屏展示页面集,用逗号隔开

  hideSingleTab: "/drm/console",                                 //隐藏单页签的页面集，用逗号隔开，只有在 singleTab 为 true 的前提下才生效
  //#endregion 逻辑交互配置区

  defaultDashboard: "/oa/dashboard",                              //默认工作台

  enableSsoLogin:false,                                         //启用ssoLogin登录
  
  resourceMark: true,                                        //数字资源是否有图像标注功能

  projectLogo: "/assets/Theme/default/img/logo.png",           //头部左侧背景图，当projectLogo为空时，显示projectName

  projectLogoWidth: "0",                                     //当projectLogo不为空时，图片的宽度(该宽度严格为图片的宽度，高度默认值26px)

  loginStyle:1,                                                //登录页风格，默认为1：表示竖版（推荐）；2：表示横版

  loginBackGround: "/assets/Theme/default/img/login-bg.jpg",   //登录页背景图

  favoriteIco: "/favicon.ico",                                 //系统ico图标

  ssoTokenName:"Zxy",                                          //SSo登录配置的token名，根据约定动态更改

  multiOrgWaterMark: false,
  
  coptyRight:"版权所有 © 2020-2023  故宫博物院  技术支持：武汉数文科技有限公司"  //版权相关声明
  //#endregion

};